import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Form,
  Container,
  Row,
  Col,
  ProgressBar,
} from "react-bootstrap";
import locale from "../../../common/locale";
import { downloadMeasurementsPis } from "../../../services/operation_tool_services";
import AppContext from "../../../context";
import "../../page/page.scss";
import { get_generic } from "../../../services/http_operations";
import { saveAs } from "file-saver";
import { downloadZip } from "client-zip";
import { faBold } from "@fortawesome/free-solid-svg-icons";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

const piSelectRef = React.createRef();
const csvSepRef = React.createRef();
const arraySepRef = React.createRef();
const floatSepRef = React.createRef();
const compressRef = React.createRef();
const deviceSelectRef = React.createRef();
const uctagSelectRef = React.createRef();
const TStagSelectRef = React.createRef();

const ucc_scenario_id ={
            "1_TT":["TS1","TS2","TS3"],
            "2_TT":["TS1","TS2","TS3"],
            "3_TT":[],
            "4_TT":[],
            "5_TT":[],
            "6_TT":["TS1","TS2a","TS2b"],
            "7_TT":["TS1","TS2","TS3"],
            "8_TT":["TS3"],
            "9_TT":["TS1","TS2"],
            "10_TT":["TS1","TS2"],
            "11_TT":["TS1","TS2","TS3","TS4"],
            "11_TT_UC4":["TS1","TS2","TS3","TS4"],
            "11_TT_UC5":["TS1","TS2"],
            "12_TT":[],
            "13_TT":["TS1","TS2","TS3"],
            "1_PR":["TS1","TS2"],
            "2_PR":["TS1","TS2a","TS2b"],
            "3_PR":["TS1","TS2","TS3"],
            "4_PR":[],
            "5_PR":[],
            "6_PR":[],
            "7_PR":["TS1","TS2"],
            "8_PR":[],
            "9_PR":["TS1","TS2"],
            "10_PR":[],
            "11_PR":["TS3"],
            "12_PR":[],
            "13_PR":[],
            "13_PR_cb":[],
            "14_PR":[]
        }


export default function DownloadPIsPage() {
  const myLogs = useContext(AppContext).logs;
  const [now, setNow] = useState(0);

  const [operationindex, setOperationIndex] = useState(0);
  const [pis, setPIs] = useState([]);
  //message for user
  const [msg, setMsg] = useState("");
  const [isError, setIsError] = useState(false);
  // TracKing selected PI type
  const [selectedPI, setSelectedPI] = useState("");
  const [Tag, setTags] = useState([]);
  const [selectedTSTag, setSelectedTSTags] = useState("");
  const [selecteduccTag, setSelecteduccTags] = useState("");
  const [Device, setDevice] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState("");
  //fetch experiments (limit 100) on load
  useEffect(() => {
    const getPIs = async () => {
      try {
        const res = await get_generic("features", {
          limit: -1,
          select: ["_id"],
        });

        setPIs(res.docs);
      } catch (error) {
        console.error(error);
      }
    };
    getPIs();
    const getTags = async () => {
          try {
            const res = await get_generic("tags", {
              limit: -1,
              select: ["_id"],
            });
    
          const containsucTags = res.docs
          .map((m) => m._id) // Assuming `_id` is the tag name ("uc1", "uc2", ...)          
          .filter((tag) => tag.includes("PR") || tag.includes("TT")) // Filter tags that contain "PR" or "TT"
          .sort((a, b) => {
            const numA = parseInt(a.slice(2)); // Extract number after "uc"
            const numB = parseInt(b.slice(2)); // Extract number after "UC"
            return numA - numB; // Sort numerically
          });

          const numTags = res.docs
          .map((m) => m._id)
          .filter(tag => /^\d+$/.test(tag)) // Only keep tags that start with "uc"
          .sort();

        const allTags = [...containsucTags, ...numTags];
  
        setTags(allTags); 

          } catch (error) {
            console.error(error);
          }
        };
        getTags();
        const getDevice = async () => {
          try {
            const res = await get_generic("devices", {
              limit: -1,
              select: ["_id"],
            });
            const filteredDevices = res.docs
              .map((d) => d._id)
              .filter((id) => !id.toLowerCase().includes("trip"));            
            setDevice(filteredDevices);
          } catch (error) {
            console.error(error);
          }
        };
        getDevice();
  }, []);

  //download history as CSV fules
  const downloadPIHandler = async () => {
    const csvSep = csvSepRef.current.value;
    const arrSep = arraySepRef.current.value;
    const floatSep = floatSepRef.current.value;
    const pi = piSelectRef.current.value;
    const expIndex = piSelectRef.current.selectedIndex;
    const compress = compressRef.current.checked;
    const ucTags = uctagSelectRef.current.value;
    const TSnumTags = TStagSelectRef.current.value;
    const device = deviceSelectRef.current ? deviceSelectRef.current.value : "";
    

    if (expIndex === 0) {
      setMsg("Please, select scenarios or full trips type");
      setIsError(true);
      return;
    }
    if (csvSep === "" || floatSep === "" || arrSep === "") {
      setMsg("Please, define all the separators");
      setIsError(true);
      return;
    }
    if (csvSep === arrSep || csvSep === floatSep || arrSep === floatSep) {
      setMsg("Please, define three different separators");
      setIsError(true);
      return;
    }
    setMsg("");
    setIsError(false);
    setNow(0);

    myLogs.PushLog({
      type: "info",
      msg: "-------Begin Download Operation " + operationindex + "-------\n",
    });

    let rename = {"device":"Type","tags":"Uc_cluster_id"};  
    let select = ["device", "samples","tags"]; 
    // let rename = {"device":"Type","tags":"Use_case"};  
    // let select = ["device", "samples","tags"]; 
    //const filters = { feature: pi };
    let filtersString='{"$and":[{"feature":"' + pi + '"}';
    if (ucTags && ucTags!=="All") filtersString = filtersString + ',{"tags":"' + ucTags + '"}';
    if (TSnumTags && TSnumTags!=="All") filtersString = filtersString + ',{"samples.0.values.1":"' + TSnumTags + '"}';
    if (device && device!=="All") filtersString = filtersString + ',{"device":"' + device + '"}';    
    filtersString = filtersString + '],"feature":"' + pi + '"}'; //for server feature check
    console.log(filtersString);
    const files = [];

    if (pi === "All") {// to remove
      for (let i = 0; i < pis.length; i++) {
        try {
          const res = await get_generic("measurements", {
            filter: filtersString,
            limit: -1,
          });
          const numDocs = res.totalDocs;

          if (numDocs === 0) {
            myLogs.PushLog({
              type: "info",
              msg:
                "The pi " +
                pis[i]._id +
                " has no records\n",
            });
            setNow(((i + 1) / pis.length) * 100);
            continue;
          }

          const f = await downloadMeasurementsPis(
            pis[i]._id,
            filtersString,
            csvSep,
            arrSep,
            floatSep,
            -1,
            rename,
            select,
            compress
          );
          files.push(f);
        } catch (error) {
          console.error(error);
        }
        setNow(((i + 1) / pis.length) * 100);
      }
    } else {
      try {
        const res = await get_generic("measurements", {
          filter: filtersString,
          limit: -1,
        });
        const numDocs = res.totalDocs;
        if (numDocs === 0) {
          myLogs.PushLog({
            type: "info",
            msg:
              "The selected " +
              pi +
              " has no records\n",
          });
          myLogs.PushLog({
            type: "info",
            msg:
              "-------End Download Operation " + operationindex + "-------\n\n",
          });
          setOperationIndex((prev) => prev + 1);
          setNow(100);
          return;
        }

        const f = await downloadMeasurementsPis(
          pi,
          filtersString,
          csvSep,
          arrSep,
          floatSep,
          -1,
          rename,
          select,
          compress
        );
        files.push(f);
      } catch (error) {
        console.error(error);
      }
    }
    if (compress === true) {
      const content = await downloadZip(files).blob();
      saveAs(content, "pis.zip");
      myLogs.PushLog({
        type: "info",
        msg: "Files compressed into pis.zip archive\n",
      });
    }
    myLogs.PushLog({
      type: "info",
      msg: "-------End Download Operation " + operationindex + "-------\n\n",
    });
    setOperationIndex((prev) => prev + 1);
    setNow(100);
  };

  return (
    <div className="page">
      <header className="page-header">Download PIs</header>
      <main className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <b>Select scenarios or full trips type</b>
            </Col>
          </Row>
          <Row>
            <Col sm={3}>
              {pis.length === 0 &&
                "No scenarios or full trip type present in database"}
              {pis.length !== 0 && (
                <Form.Select
                  aria-label={"All"}
                  ref={piSelectRef}
                  onChange={(e) => setSelectedPI(e.target.value)} // Track the selection
                >
                  <option>{locale().select}</option>
                  {React.Children.toArray(
                    pis.map((e) => {
                      return <option value={e["_id"]}>{e["_id"]}</option>;
                    })
                  )}
                </Form.Select>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              {pis.length !== 0 && (
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Compress files in a single .zip archive"
                    ref={compressRef}
                  />
                </Form.Group>
              )}
            </Col>
          </Row>
        {/* New Dropdowns */}
          <Row style={{ marginTop: "20px" }}>
            <Col>
              <b>Select Use Case Cluster</b>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col sm={3}>
              <Form.Select
                aria-label="All"
                ref={uctagSelectRef}
                onChange={(e) => {
                  setSelecteduccTags(e.target.value);
                  }}
                style={faBold}
                disabled={Tag.length === 0} // Disable if no UCC
              >
                <option>{Tag.length === 0 ? "No UCC in database" : "All"}</option>
                {Tag.map((Tag, index) =>
                  (
                    <option key={index} value={Tag}>
                      {Tag}
                    </option>
                  )
                )}
              </Form.Select>
            </Col>
          </Row>

          

          <Row style={{ marginTop: "20px" }}>
            <Col>
              <b>Select test scenario ID</b>
            </Col>
          </Row>
          <Row>
          <Col sm={3}>
                <Form.Select
                  aria-label="Select test scenario ID"
                  ref={TStagSelectRef}
                  onChange={(e) => setSelectedTSTags(e.target.value)}
                  style={faBold}
                   disabled={
                    selecteduccTag=="" || selecteduccTag=== "All" || ucc_scenario_id[selecteduccTag]?.length === 0 // Disable if no UCC is selected
                    // Disable if the selected UCC has no scenarios
                              }
                            >
                              <option>{ucc_scenario_id[selecteduccTag]?.length === 0 ? "All" : "All"}</option>
                              {ucc_scenario_id[selecteduccTag]?.map((scenario, index) => (
                              <option key={index} value={scenario}>
                                {scenario}
                              </option>
                              ))}
                            </Form.Select>
                          </Col>
                        </Row> 
                        {/* This drop down depends on the selection of PI type */}  
          {selectedPI === "Scenarios" && (
          <>
            <Row style={{ marginTop: "20px" }}>
              <Col>
                <b>Select type</b>
              </Col>
            </Row>
            <Row>
            <Col sm={3}>
             
                <Form.Select
                  aria-label="Select type"
                  ref={deviceSelectRef}
                  onChange={(e) => setSelectedDevice(e.target.value)}
                  style={faBold} 
                  disabled={Device.length === 0}
                >
                  <option>{Device.length === 0 ? "No device in database" : "All"}</option>
                  {Device.map((Device, index) =>
                  (
                    <option key={index} value={Device}>
                      {Device}
                    </option>
                  )
                )}
                </Form.Select>
            </Col>
            </Row>
          </>
        )}
        <Row style={{ marginTop: "20px" }}>
            <Col>
              <Row>
                <Col>
                  {pis.length !== 0 && <b>Define CSV separators</b>}
                </Col>
              </Row>{" "}
              {pis.length !== 0 && (
                <Row style={{ paddingTop: 10 + "px" }}>
                  <Col xxl={1} xl={2} lg={4} sm={3}>
                    <Form.Group className="mb-3">
                      <Form.Select
                        aria-label="CSV Column Separator"
                        ref={csvSepRef}
                      >
                        <option value=",">,</option>
                        <option value=";">;</option>
                        <option value="-">-</option>
                        <option value="\t">\t</option>
                      </Form.Select>
                      <Form.Text className="text-muted">
                        Column separator
                      </Form.Text>
                    </Form.Group>
                  </Col>
                  <Col xxl={1} xl={2} lg={4} sm={3}>
                    <Form.Group className="mb-3">
                      <Form.Select
                        aria-label="CSV Array separator"
                        ref={arraySepRef}
                      >
                        <option value=";">;</option>
                        <option value=",">,</option>
                        <option value=".">.</option>
                        <option value="-">-</option>
                      </Form.Select>
                      <Form.Text className="text-muted">
                        Array separator
                      </Form.Text>
                    </Form.Group>
                  </Col>
                  <Col xxl={1} xl={2} lg={4} sm={3}>
                    <Form.Group className="mb-3">
                      <Form.Select
                        aria-label="CSV Floating Point separator"
                        ref={floatSepRef}
                      >
                        <option value=".">.</option>
                        <option value=",">,</option>
                      </Form.Select>
                      <Form.Text className="text-muted">
                        Floating Point separator
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>
              )}
              <Row>
                <Col>
                  {pis.length !== 0 && (
                    <Button
                      variant="primary"
                      onClick={downloadPIHandler}
                    >
                      Download PIs
                    </Button>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <font
                style={{
                  marginLeft: 5 + "px",
                  color: isError ? "red" : "black",
                }}
              >
                {msg}
              </font>
            </Col>
          </Row>
          <Row style={{ paddingTop: 10 + "px", paddingBottom: 10 + "px" }}>
            <Col>
              <ProgressBar
                now={now}
                label={`${now}%`}
                variant={now === 100 ? "success" : "info"}
              />
            </Col>
          </Row>
          <Row style={{ paddingTop: 10 + "px", paddingBottom: 10 + "px" }}>
            <Col>
              <b>Operation logs</b>
            </Col>
          </Row>
          <Row>
            <Col>
              <textarea
                id="logger"
                style={{ resize: "both", width: 30 + "vw", height: 30 + "vh" }}
                //cols="100"
                //rows="10"
                readOnly
                value={myLogs.logs
                  .map((l) => l.msg)
                  .reverse()
                  .join("-")}
              />
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}
